export const COLORS = [
  "#ffffff",
  "#000000",
  "#ffff00",
  "#ffcc00",
  "#ff8800",
  "#ff2222",
  "#ff66cc",
  "#aa44ff",
  "#00cfff",
  "#00dd44",
];

export const THICKNESSES = [2, 5, 10];

export const STICKERS = [
  { id: "checkmark", url: "/stickers/checkmark.png", name: "Checkmark" },
  { id: "cross", url: "/stickers/cross.png", name: "X Mark" },
  { id: "thumbs_up", url: "/stickers/thumbs_up.png", name: "Thumbs Up" },
  { id: "thumbs_down", url: "/stickers/thumbs_down.png", name: "Thumbs Down" },
  { id: "warning", url: "/stickers/warning.png", name: "Warning" },
  { id: "approved", url: "/stickers/approved.png", name: "Approved" },
  { id: "finished", url: "/stickers/finished.png", name: "Finished" },
  { id: "start", url: "/stickers/start.png", name: "Start" },
  { id: "end", url: "/stickers/end.png", name: "End" },
  { id: "red_dot", url: "/stickers/red_dot.png", name: "Red Dot" },
  { id: "green_dot", url: "/stickers/green_dot.png", name: "Green Dot" },
  { id: "yellow_dot", url: "/stickers/yellow_dot.png", name: "Yellow Dot" },
  { id: "blue_dot", url: "/stickers/blue_dot.png", name: "Blue Dot" },
  { id: "check_green", url: "/stickers/check_green.png", name: "Green Check" },
  { id: "x_red", url: "/stickers/x_red.png", name: "Red X" }
];

